// shared-components/components/Logo.jsx
import React from 'react';

function CompudoptLogo({ size = 36 }) {
  return (
    <div 
      className="compudopt-logo"
      style={{ 
        width: size, 
        height: size,
        background: 'var(--compudopt-green)', // Use solid green to match web helper
        borderRadius: '50%',
        display: 'grid',
        placeItems: 'center',
        boxShadow: 'var(--shadow-md)'
      }}
    >
      <svg 
        width={size * 0.5} 
        height={size * 0.5} 
        viewBox="0 0 24 24" 
        fill="none"
        aria-hidden="true"
      >
        <path 
          d="M12 2v8" 
          stroke="#fff" 
          strokeWidth="2.5" 
          strokeLinecap="round"
        />
        <path 
          d="M6.2 6.2a8 8 0 1011.6 0" 
          stroke="#fff" 
          strokeWidth="2.5" 
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}

export default CompudoptLogo;
